import React from "react"
import { UserBadge } from "components-design-system"

const UserFullnameCellRenderer = ({ value, size = "sm", showFullName }) => {
  if (!value) {
    return
  }

  if (Array.isArray(value)) {
    return (
      <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
        {value.map((user) => (
          <UserBadge
            user={user}
            size={size}
            showFullName={showFullName}
          />
        ))}
      </div>
    )
  }
  return (
    <UserBadge
      user={value}
      showFullName={showFullName}
    />
  )
}

export default UserFullnameCellRenderer
